/* eslint-disable import-x/no-default-export -- Default export is required */
import { config } from '@opendoor/bricks-next';

export default config;
